import React from 'react'
import { Button, Grid, LinearProgress, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@material-ui/core";
import { Theme, makeStyles, createStyles } from '@material-ui/core/styles';
import { observer } from "mobx-react-lite";
import MapWithImageLayer from "./MapWithImageLayer";

import estimateStore from "../stores/estimateStore";
import estimateContextStore from '../stores/estimateContextStore';
import estimateResultToCardData from './EstimateResultToCardData';
import GaugeChart from 'react-gauge-chart'

import { Alert } from "@material-ui/lab";


const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: '100%',
        },
        button: {
            marginRight: theme.spacing(1),
        },
        instructions: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1),
        },
        card:{
            margin: theme.spacing(1),
            border: '1px solid gray',
            borderRadius: 5,
            boxShadow: '0 2px 4px rgb(0 0 0 / 30%)', 
            padding: 20,
            marginTop: theme.spacing(3),
        },
        padding: {
            padding: 10
        },
        estimateButton: {
            backgroundColor: 'green',
            padding: theme.spacing(3),
            margin: theme.spacing(2),
            color: 'white'
        },
    }),
);

const EstimateResult = ()=>{
    const classes = useStyles()

    if(!estimateStore.loading){
       return(
            <Grid>
                <Grid item xs={12}>
                    <div style={{color: "gray", fontSize: 14}}>How to: <br/>Input Estimate Context -&gt; Select interested area -&gt; Click following "ESTIMATE" button</div>
                    <br/>
                    <Button variant="contained" onClick={()=>estimateStore.requestEstimate()} size="large" className={classes.estimateButton}>
                        Estimate
                    </Button>
                </Grid>
                {
                    estimateStore.planningEstimateResult.datasets&&estimateStore.planningEstimateResult.datasets.map(estimate=>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography variant='h4'>Estimate Context:</Typography>
                                <li>Estimate Mode: {estimateContextStore.mode}</li>
                                <li>Data Layer: {estimate.name}</li>
                                <li>Event or Action: {estimateContextStore.planningActionType}</li>
                                <li>Selected Size: {Math.round(estimateStore.planningEstimateResult.assessment_area).toLocaleString()} ha</li>
                            </Grid>
                            <Grid item xs={12}>
                                <iframe title="chart" style={{border:'none', width:'100%', height: '840px',}} srcDoc={estimate.figure}></iframe>
                                {/* <div className="content" dangerouslySetInnerHTML={{__html: estimate.figure}}></div> */}

                                {/* <Charts data={estimateStore.chartData} /> */}
                                {/* <img width='100%' src={`data:image/gif;base64,${estimate.figure}`} /> */}
                                {/* <img src={`data:image/gif;base64,${estimate.geotiff}`} /> */}

                            </Grid>
                            
                            { estimate.name === 'biodiversity-persistence' && estimate.summary.mean_species_persistence_changes.values.expected_change < 0.5 && <>
                                <Grid item xs={12}>
                                    <Alert severity="warning">The above chart displays the contribution of the area of interest to the number of additional plant species expected to persist.
                                    The summary statistics in the cards below may show a decline in overall biodiversity persistence, despite an increase above, because of changes in regional habitat outside the area of interest.
                                    </Alert>
                                </Grid>
                            </>}
                            
                            { estimate.name === 'habitat-condition' && <>
                            <Grid item xs={12}>
                                <Typography variant='h5'>For the area selected of {Math.round(estimateStore.planningEstimateResult.assessment_area).toLocaleString()} ha, the following results for habitat condition are returned:</Typography>
                            </Grid>
                            </>}

                            { estimate.name === 'biodiversity-persistence' && <>
                            <Grid item xs={12}>
                                <Typography variant='h5'>The number of plant species expected to persist in the area selected of {Math.round(estimateStore.planningEstimateResult.assessment_area).toLocaleString()} ha:</Typography>
                            </Grid>
                            </>}

                            { estimate.name === 'tree-height' && <>
                            <Grid item xs={12}>
                                <Typography variant='h5'>The average tree height across the area selected of {Math.round(estimateStore.planningEstimateResult.assessment_area).toLocaleString()} ha:</Typography>
                            </Grid>
                            </>}

                            <Grid item container spacing={2}>
                            {
                                estimateResultToCardData(estimate).map(cardData => 
                                <Grid item xs={4}>
                                    <MapWithImageLayer cardData={cardData} />
                                </Grid>)
                            }
                            </Grid>
                            <br/>
                            <br/>
                            {
                                //estimate.summary.potential_change_habitat_area && estimate.name === 'habitat-condition' && <Grid container className={classes.card}>
                                (estimate.name === 'habitat-condition' || estimate.name === 'habitat-connectivity') && <Grid container className={classes.card}>
                                    <Grid item xs={9}><Typography variant='h5' align='left'>Estimated change in equivalent habitat area {estimate.summary.estimatedActionYear} to {estimate.summary.estimatedEndYear}</Typography> </Grid>
                                    <Grid item xs={3}><Typography variant='h4' align='right' style={{color: 'green'}}>{estimate.summary.potential_change_habitat_area.values.potential_change_ha>=0? '+'+estimate.summary.potential_change_habitat_area.values.potential_change_ha.toLocaleString(): estimate.summary.potential_change_habitat_area.values.potential_change_ha.toLocaleString()} {estimate.summary.potential_change_habitat_area.units}</Typography></Grid>
                                </Grid>
                            }

                            {
                                //estimate.summary.potential_change_habitat_area && estimate.name === 'tree-height' && <Grid container className={classes.card}>
                                estimate.name === 'tree-height' && <Grid container className={classes.card}>
                                    <Grid item xs={9}><Typography variant='h5' align='left'>Estimated change in area of trees taller than &gt; 3m from {estimate.summary.estimatedActionYear?estimate.summary.estimatedActionYear:estimate.summary.estimatedStartYear} to {estimate.summary.estimatedEndYear}</Typography> </Grid>
                                    <Grid item xs={3}><Typography variant='h4' align='right' style={{color: 'green'}}>{estimate.summary.potential_change_habitat_area.values.potential_change_ha>=0? '+'+estimate.summary.potential_change_habitat_area.values.potential_change_ha.toLocaleString(): estimate.summary.potential_change_habitat_area.values.potential_change_ha.toLocaleString()} {estimate.summary.potential_change_habitat_area.units}</Typography></Grid>
                                </Grid>
                            }

                            {
                                //estimate.summary.potential_change_habitat_area && estimate.name === 'tree-height' && <Grid container className={classes.card}>
                                estimate.name === 'threatened-species' && <Grid container className={classes.card}>
                                    <Grid item xs={8}><Typography variant='h5' align='left'>Estimated change in species hectares from {estimate.summary.estimatedActionYear?estimate.summary.estimatedActionYear:estimate.summary.estimatedStartYear} to {estimate.summary.estimatedEndYear}</Typography> </Grid>
                                    <Grid item xs={4}>
                                        <Typography variant='h4' align='right' style={{color: 'green'}}>{estimate.summary.sum_changes.values.expected_change>=0? '+'+estimate.summary.sum_changes.values.expected_change.toLocaleString(): estimate.summary.sum_changes.values.expected_change.toLocaleString()}</Typography>
                                        <Typography variant='h4' align='right' style={{color: 'green'}}> {estimate.summary.sum_changes.units}</Typography>
                                    </Grid>
                                </Grid>
                            }

                            {
                                estimate.name === 'biodiversity-persistence' && <Grid container className={classes.card}>
                                    <Grid item xs={9}>
                                        <Typography variant='h5' align='left'>
                                        Number of additional plant species persisting {estimate.summary.estimatedActionYear||estimate.summary.estimatedStartYear} to {estimate.summary.estimatedEndYear}
                                        </Typography> </Grid>
                                    <Grid item xs={3}>
                                        <Typography variant='h4' align='right' style={{color: 'green'}}>
                                            {estimate.summary.mean_species_persistence_changes.values.additional_species}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            }
                            {
                                estimate.name === 'biodiversity-persistence' && <Grid container className={classes.card}>
                                    <Grid item xs={5}>
                                        <Typography variant='h5' align='left'>
                                            Progress toward full potential gain in number of plant species persisting
                                        </Typography> </Grid>
                                    <Grid item xs={5}>
                                        <GaugeChart  
                                            nrOfLevels={7} 
                                            colors={["#c3d5bb", "#afc8a4", "#9bba8e", "#87ac77", "#739f60", "#5f914a", "#4b8333"]} 
                                            textColor="gray"
                                            percent={estimate.summary.mean_species_persistence_changes.values.progress.percent/100} 
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography variant='h6' align='left' style={{color: 'green'}}>
                                            Start: {estimate.summary.mean_species_persistence_changes.values.progress.start}
                                        </Typography>
                                        <Typography variant='h6' align='left' style={{color: 'green'}}>
                                            Potential: {estimate.summary.mean_species_persistence_changes.values.progress.potential}
                                        </Typography>
                                        <Typography variant='h6' align='left' style={{color: 'green'}}>
                                            Estimate: {estimate.summary.mean_species_persistence_changes.values.progress.estimate}
                                        </Typography>
                                        <Typography variant='h6' align='left' style={{color: 'green'}}>
                                            Percent: {estimate.summary.mean_species_persistence_changes.values.progress.percent} %
                                        </Typography>
                                    </Grid>

                                </Grid>
                            }

{
                                estimate.name === 'threatened-species' && <Grid container className={classes.card}>
                                    <Grid item xs={5}>
                                        <Typography variant='h5' align='left'>
                                            Progress toward full potential threatened species habitat provision
                                        </Typography> </Grid>
                                    <Grid item xs={5}>
                                        <GaugeChart  
                                            nrOfLevels={7} 
                                            colors={["#c3d5bb", "#afc8a4", "#9bba8e", "#87ac77", "#739f60", "#5f914a", "#4b8333"]} 
                                            textColor="gray"
                                            percent={estimate.summary.sum_changes.values.progress.percent/100} 
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Typography variant='h6' align='left' style={{color: 'green'}}>
                                            Start: {estimate.summary.sum_changes.values.progress.start}
                                        </Typography>
                                        <Typography variant='h6' align='left' style={{color: 'green'}}>
                                            Potential: {estimate.summary.sum_changes.values.progress.potential}
                                        </Typography>
                                        <Typography variant='h6' align='left' style={{color: 'green'}}>
                                            Estimate: {estimate.summary.sum_changes.values.progress.estimate}
                                        </Typography>
                                        <Typography variant='h6' align='left' style={{color: 'green'}}>
                                            Percent: {estimate.summary.sum_changes.values.progress.percent} %
                                        </Typography>
                                    </Grid>

                                </Grid>
                            }
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                        </Grid>)
                }
                <Dialog
                    open={estimateStore.showContextAlert}
                    onClose={estimateStore.closeContextAlert}
                >
                    <DialogTitle>You missed following context</DialogTitle>
                    <DialogContent>
                    {
                        estimateStore.messages.map(message=>
                            <DialogContentText>{message}</DialogContentText>
                            )
                    }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={estimateStore.closeContextAlert}>Close</Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        )
    }else  return <div style={{minHeight:'30vh', marginTop: '150px'}}><LinearProgress /></div>
}

export default observer(EstimateResult)